import React, { useState } from 'react'
import classNames from 'classnames'

import CommunityTooltipMenu from 'shared/components/community/components/tooltip-menu/CommunityTooltipMenu'
import PostTime from 'shared/components/community/components/post/time/PostTime'
import ReadMoreText from 'shared/components/community/components/post/read-more-text/ReadMoreText'
import CommentForm from 'shared/components/community/comment/form/CommentForm'
import { LoadingSpinner } from '@elo-kit/components/loading-spinner/LoadingSpinner'

import Avatar from 'shared/components/community/components/avatar/Avatar'
import { SIZES, POSITIONS } from '@elo-kit/constants/general.constants'

import { createId } from '@elo-kit/utils/general.utils'
import { withStores } from 'utils/helpers.utils'

import './community-comment.scss'

const CommunityComment = (props) => {
  const {
    comment,
    withoutTopBorder,
    withoutBottomBorder,
    commentsLength,
    communityId,
    communityPostsStore,
    communityMemberStore,
    isPayerCabinet,
  } = props
  const { item: currentMember } = communityMemberStore
  const { id, postId, content, createdAt, updatedAt, member, memberId: commentMemberId, edited } = comment || {}
  const { avatar, username } = member || {}
  const { cropped: croppedLink, original: avatarLink } = avatar?.[0] || {}

  const [editCommentMode, setEditCommentMode] = useState(false)

  const isCommentOwner = currentMember?.id === commentMemberId

  const handleDeleteComment = async () => {
    const reqData = { communityId, postId }

    await communityPostsStore.deleteComment(id, reqData)
    await communityPostsStore.fetchComments(reqData)
  }

  const deleteMenuItem = [
    {
      show: true,
      content: I18n.t('react.shared.button.delete'),
      action: handleDeleteComment,
    },
  ]

  const editMenuItem = [
    {
      show: true,
      content: I18n.t('react.shared.button.edit'),
      action: () => setEditCommentMode(true),
    },
  ]

  const tooltipMenuItems = [
    ...(!isCommentOwner && isPayerCabinet ? [] : deleteMenuItem),
    ...(isCommentOwner && !currentMember.muted ? editMenuItem : []),
  ]

  const communityCommentClasses = classNames('community-comment', {
    'community-comment--without-top-border': withoutTopBorder,
    'community-comment--without-bottom-border': withoutBottomBorder,
  })

  const commentContent = editCommentMode ? (
    <CommentForm
      {...{
        comment,
        setEditCommentMode,
        postId,
        communityId,
      }}
    />
  ) : (
    <div className={communityCommentClasses}>
      <div className='community-comment__flex-container'>
        <div className='community-comment__image-container'>
          <Avatar imageUrl={croppedLink || avatarLink} small />
          <div className='community-comment--left-margin'>
            <div className='community-comment__author-container'>
              <div className='community-comment__author-name'>{username}</div>
              <PostTime
                key={createId(comment.id, commentsLength)}
                edited={edited}
                createdTime={createdAt}
                editedTime={updatedAt}
              />
            </div>
            <div className='community-comment__text'>
              <ReadMoreText text={content} />
            </div>
          </div>
        </div>
        <div className='community-comment__text community-comment__text--mobile'>
          <ReadMoreText text={content} />
        </div>
      </div>
      {(isCommentOwner || !isPayerCabinet) && (
        <div className='community-comment__actions'>
          <CommunityTooltipMenu id={createId(id, postId)} menuItems={tooltipMenuItems} placement={POSITIONS.bottom} />
        </div>
      )}
    </div>
  )

  return (
    <>
      {communityPostsStore.commentsLoadingById[id] ? (
        <LoadingSpinner className='loading-spinner__medium-container' size={SIZES.small} />
      ) : (
        commentContent
      )}
    </>
  )
}

export default withStores(['communityPostsStore', 'communityMemberStore'], CommunityComment)
